import React from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import CadastrarReembolso from "../views/reembolso/CadastrarReembolso";
import DetalharReembolso from "../views/reembolso/DetalharReembolso";
import ListarReembolso from "../views/reembolso/ListarReembolso";

import ListarFatura from "../views/fatura/ListarFatura";
import DetalharFatura from "../views/fatura/DetalharFatura";

import CadastroConfiguracoes from "../views/sistema/CadastroConfiguracoes";
import ResetSenha from "../views/sistema/ResetSenha";

import Login from "../login/form/Login";
import RecuperarSenha from "../login/form/RecuperarSenha";

import ProtectedRoute from "./ProtectedRoute";
import AxiosNavigation from "./AxiosNavigation";

import DashBoard from "../views/dashboard/Dashboard";
import PageNotFound from "../views/util/PageNotFound";


const Rotas = () => {
    return (
        <AnimatePresence>
            <Router>
                <AxiosNavigation />
                <Routes>

                    {/* LOGIN */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Login />} />
                    <Route path="/recuperarSenha" element={<RecuperarSenha />} />

                    {/* DASHBOARD - Admin NÃO pode ver */}
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute view="dashboard">
                                <DashBoard />
                            </ProtectedRoute>
                        }
                    />

                    {/* FATURA - Admin pode */}
                    <Route
                        path="/fatura"
                        element={
                            <ProtectedRoute view="fatura"roles={["ROLE_FATURAS_CONSOLIDADORA"]}>
                                <ListarFatura />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/detalharFatura"
                        element={
                            <ProtectedRoute view="fatura" roles={["ROLE_FATURAS_CONSOLIDADORA"]}>
                                <DetalharFatura />
                            </ProtectedRoute>
                        }
                    />

                    {/* REDEFINIR SENHA - todos podem */}
                    <Route
                        path="/redefinirSenha"
                        element={
                            <ProtectedRoute view="resetSenha">
                                <ResetSenha />
                            </ProtectedRoute>
                        }
                    />

                    {/* REEMBOLSO - Admin pode ver listar/detalhar */}
                    <Route
                        path="/reembolso"
                        element={
                            <ProtectedRoute view="reembolso" roles={["ROLE_REEMBOLSO"]}>
                                <ListarReembolso />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path="/detalharReembolso"
                        element={
                            <ProtectedRoute view="reembolso" roles={[
                                "ROLE_REEMBOLSO"
                            ]}>
                                <DetalharReembolso />
                            </ProtectedRoute>
                        }
                    />

                    {/* Cadastrar reembolso - Admin NÃO pode */}
                    <Route
                        path="/cadastrarReembolso"
                        element={
                            <ProtectedRoute view="reembolso" roles={[
                                "ROLE_REEMBOLSO"
                            ]}>
                                <CadastrarReembolso />
                            </ProtectedRoute>
                        }
                    />

                    {/* CONFIGURAÇÕES - Admin NÃO pode */}
                    <Route
                        path="/sistema"
                        element={
                            <ProtectedRoute view="config" roles={[
                                "ROLE_REEMBOLSO"
                            ]}>
                                <CadastroConfiguracoes />
                            </ProtectedRoute>
                        }
                    />

                    {/* NOT FOUND */}
                    <Route path="*" element={<PageNotFound />} />

                </Routes>
            </Router>
        </AnimatePresence>
    );
};

export default Rotas;